import { HttpBackend, HttpEvent, HttpEventType, HttpRequest, HttpResponse } from '@angular/common/http';
import { DOCUMENT, Injectable, inject } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AUTH_COOKIE_SESSION } from './environment.constants';
import { Environment } from './environment.interface';
import { toSameOriginApiUrls } from './environment.util';
import { Info } from './info.interface';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  private readonly http = inject(HttpBackend);
  private readonly apiOrigin: string | null = inject(AUTH_COOKIE_SESSION) ? inject(DOCUMENT).location.origin : null;

  environment: Environment = { locale: 'en-AE', branding: 'aspire' } as Environment;
  info: Info;

  loadEnvironment$(): Observable<Environment> {
    return this.http
      .handle(new HttpRequest('GET', `./assets/environment/environment.json?v=${new Date().getTime()}`))
      .pipe(
        filter((event: HttpEvent<Environment>) => event.type === HttpEventType.Response),
        map((response: HttpEvent<Environment>) => (response as HttpResponse<Environment>).body as Environment),
        map((e: Environment) => (this.apiOrigin ? toSameOriginApiUrls(e, this.apiOrigin) : e)),
        tap((e: Environment) => (this.environment = e)),
      );
  }

  loadInfo$(): Observable<Info> {
    return this.http.handle(new HttpRequest('GET', `./assets/info.json?v=${new Date().getTime()}`)).pipe(
      filter((event: HttpEvent<Info>) => event.type === HttpEventType.Response),
      map((response: HttpEvent<Info>) => (response as HttpResponse<Info>).body as Info),
      tap((e: Info) => (this.info = e)),
    );
  }
}
